import { connector } from "utils/common/connector";

const controller = "team";

// ---------------------------------------------
// GET TEAMS BY COMPANY (PAGINATED)
// ---------------------------------------------
export const getTeamsByCompanyService = async (params) => {
  let reply;

  try {
    const response = await connector.get(
      controller,
      "getTeamsByCompany",
      params,
    );

    reply = {
      teams: response?.teams ?? [],
      totalTeams: response?.totalRecords ?? 0,
    };
  } catch (error) {
    console.log(error);
    reply = {
      teams: [],
      totalTeams: 0,
    };
  }

  return reply;
};

// ---------------------------------------------
// GET TEAM MEMBERS
// ---------------------------------------------
export const getTeamMembersService = async (params) => {
  let reply;

  try {
    const response = await connector.get(controller, "getTeamsMembers", params);

    reply = {
      teams: response?.users ?? [],
      totalTeams: response?.totalRecords ?? 0,
    };
  } catch (error) {
    console.log(error);
    reply = {
      teams: [],
      totalTeams: 0,
    };
  }

  return reply;
};

// ---------------------------------------------
// GET TEAM BY ID
// ---------------------------------------------
export const getTeamByIdService = async (params) => {
  let reply;

  try {
    const response = await connector.get(controller, "getTeamById", params);

    reply = {
      team: response ?? {},
    };
  } catch (error) {
    console.log(error);
    reply = {
      team: {},
    };
  }

  return reply;
};

// ---------------------------------------------
// CREATE TEAM
// ---------------------------------------------
export const createTeamService = async (params) => {
  let reply;

  try {
    const response = await connector.post(controller, "createTeam", params);

    reply = response ?? { success: false };
  } catch (error) {
    console.log(error);
    reply = { success: false };
  }

  return reply;
};
